var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExchangeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876:2585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0622 8.90865C14.0622 10.2211 13.2747 10.3148 13.1247 10.3148H1.59874L4.07831 7.83527L3.4174 7.16968L0.136312 10.4508C-0.0454372 10.6336 -0.0454372 10.9288 0.136312 11.1117L3.4174 14.3928L4.07831 13.7319L1.59874 11.2523H13.1247C13.7716 11.2523 14.9996 10.7836 14.9996 8.90865V7.50247H14.0622V8.90865Z",
    fill: "#121933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.938492 6.09622C0.938492 4.78378 1.72595 4.69003 1.87595 4.69003H13.4019L10.9224 7.1696L11.5833 7.83051L14.8644 4.54942C15.0461 4.36658 15.0461 4.07134 14.8644 3.88851L11.5833 0.607422L10.9177 1.27301L13.4019 3.75258H1.87595C1.2291 3.75258 0.0010376 4.22131 0.0010376 6.09622V7.5024H0.938492V6.09622Z",
    fill: "#121933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876:2585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchangeDark);
export default __webpack_public_path__ + "static/media/icon-exchange-dark.8e9c408c.svg";
export { ForwardRef as ReactComponent };